import hasFullName from './hasFullName';

const hasOit = (includedOit) => {
  return Object.assign(
    { ...includedOit },
    hasFullName(includedOit),
  );
};

export default hasOit;
